/**
 * LES NOMS D'ARTICLES EN DARIJA
 * =============================
 *
 * Une partie des fournisseurs ne lit pas le francais. Traduire les boutons
 * ne suffisait pas : c'est le NOM DU PRODUIT qu'ils doivent reconnaitre pour
 * preparer la commande.
 *
 * La table vient du fichier « arabe.xlsx » fourni par la direction, 768
 * articles, cle = le SKU (l'identifiant Glovo du produit). Elle est
 * embarquee dans l'application plutot que stockee en base : un nom de
 * produit ne change pas tous les jours, et l'ecran n'a ainsi aucune lecture
 * supplementaire a faire pour afficher la commande.
 *
 * Sans traduction connue, on garde le nom francais : un article sans nom
 * serait pire qu'un article dans la mauvaise langue.
 */

import table from "@/lib/data/noms-ar.json";

const NOMS: Record<string, string> = table as Record<string, string>;

/**
 * Le nom a afficher pour cet article.
 *
 * @param sku identifiant du produit (glovoProductId / sku)
 * @param nomFrancais le nom du catalogue, utilise en secours
 * @param langue "ar" pour la darija, sinon le francais est rendu tel quel
 * @param nomAr la correction saisie par l'admin, si elle existe. Elle passe
 *              DEVANT la table embarquee : un mot corrige a la main l'a ete
 *              parce que celui du fichier etait faux.
 */
export function nomArticle(
  sku: unknown,
  nomFrancais: unknown,
  langue: string,
  nomAr?: unknown,
): string {
  const fr = String(nomFrancais ?? "");
  if (langue !== "ar") return fr;
  const corrige = String(nomAr ?? "").trim();
  if (corrige) return corrige;
  const cle = String(sku ?? "").trim();
  return (cle && NOMS[cle]) || fr;
}
